export default __webpack_public_path__ + "static/media/p1-6.143612e3.png";